import { render, staticRenderFns } from "./wechatShare.vue?vue&type=template&id=d1488708&scoped=true&"
import script from "./wechatShare.vue?vue&type=script&lang=js&"
export * from "./wechatShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1488708",
  null
  
)

export default component.exports